import React from 'react'
import { useContext } from 'react'
import { AuthContext } from '../../App'
import { useState } from 'react'
import { createForm } from '../../utils/newforms/createForm'
import StatusMessage, {
  useStatusMessage,
} from '../../ui/StatusMessage/StatusMessage'
import isFormValid from '../../utils/newforms/validation/isFormValid'
import getFormValues from '../../utils/newforms/getFormValues'
import pattern from './assets/pattern.svg'
import { functions } from '../../config/firebase'
import FormRender from '../../utils/newforms/render/FormRender'
import Button from '../../ui/Button/Button'
import getFieldRenderObject from '../../utils/newforms/render/getFieldRenderObject'
import './RequestConsultation.sass'
import SectionTitle from '../../ui/SectionTitle/SectionTitle'
import consult from './assets/consult.svg'

function RequestConsultation() {
  const { city } = useContext(AuthContext)
  const [form, setForm] = useState(
    createForm({
      formPattern: new ConsultForm(),
    })
  )
  const [isLoading, setIsLoading] = useState(false)
  const [showErrors, setShowErrors] = useState(false)
  const [statusMessage, setStatusMessage] = useStatusMessage()

  const onSubmit = async (e) => {
    e.preventDefault()
    if (!isFormValid({ form })) {
      return setStatusMessage({
        show: true,
        type: 'fail',
        message: 'Будь ласка, заповніть усі поля форми',
        closeAfter: 5000,
      })
    }
    setIsLoading(true)

    const values = getFormValues({ form })

    console.log('🚀 ~ onSubmit ~ values:', values)
    const func = functions.httpsCallable('emailSender')
    const text = `
      Ім'я клієнта: ${values.userName}<br/>
      Телефон: ${values.phone.value}<br/>
      Об'єм замовлення: ${values.volume}<br/>
    `

    // sendSms({ message: text })

    func({
      subject: 'Запит на консультацію',
      to: 'syriuszahid.admin@ukr.net',
      // to: 'iseeblog1@gmail.com',
      html: text,
    }).then(({ data }) => {
      if (data === 'success') {
        setStatusMessage({
          show: true,
          type: 'success',
          message:
            'Ми отримали Ваш запит. Наші спеціалісти звяжуться з Вами найближчим часом',
          closeAfter: 5000,
        })
        setForm(createForm({ formPattern: new ConsultForm() }))
        return setIsLoading(false)
      }
    })
  }

  return (
    <div
      className="RequestConsultation"
      style={{ backgroundImage: `url(${consult})` }}
    >
      <div
        className="RequestConsultation-Container DefaultContainer Pattern"
        style={{ backgroundImage: `url(${pattern})` }}
      >
        <SectionTitle title="Замовити дзвінок" />
        <p>Наші спеціалісти готові надати консультацію по будь-якому питанню</p>
        {statusMessage.show && (
          <StatusMessage
            className="Site-StatusMessage"
            type={statusMessage.type}
            message={statusMessage.message}
          />
        )}
        <div className="RequestConsultation-Form">
          <FormRender
            sections={[{ fields: ['userName', 'phone', 'volume'] }]}
            form={form}
            setForm={setForm}
            errors={showErrors}
          />
          <Button
            theme="primary"
            icon="phone"
            iconWeight="solid"
            title="Замовити дзвінок"
            isLoading={isLoading}
            onClick={onSubmit}
          />
        </div>
        <p className="Caption-Medium">
          Надсилаючи цю форму ви погоджуєтесь з нашою{' '}
          <a
            href="https://firebasestorage.googleapis.com/v0/b/pavliv-2c3a3.appspot.com/o/pdf%2Fpersonal.pdf?alt=media"
            target="blank"
          >
            політикою конфіденційності
          </a>
        </p>
      </div>
    </div>
  )
}

class ConsultForm {
  constructor() {
    this.userName = {
      field: {
        fieldId: 'userName',
        fieldType: 'input',
        inputType: 'text',
        placeholder: `Ваше ім'я`,
        required: true,
      },
      render: getFieldRenderObject(),
    }
    this.phone = {
      field: {
        fieldId: 'phone',
        fieldType: 'phone',
        inputType: 'text',
        placeholder: 'Телефон',
        required: true,
      },
      render: getFieldRenderObject(),
    }
    this.volume = {
      field: {
        fieldId: 'volume',
        fieldType: 'select',
        placeholder: `Об'єм замовлення`,
        required: true,
        getOptions: [
          {
            label: 'Маса замовлення менше 2т.',
            value: 'Маса замовлення менше 2т.',
          },
          {
            label: 'Маса замовлення більше 2т.',
            value: 'Маса замовлення більше 2т.',
          },
        ],
      },
      render: getFieldRenderObject(),
    }
  }
}

export default RequestConsultation
